import React, { useContext, useEffect } from "react";
import _ from "lodash";
import moment from "moment";
import Select from "react-select";
// import { RiRefreshFill } from "react-icons/ri";
import { AppContext } from "../../../context/AppContext";
import CustomCalendar from "../../CustomCalender/index";
import { useRef } from "react";
import SelectApplicants from "../SelectApplicants/SelectApplicants";
import { checkModuleGeneralPermission } from "../../../helpers/helpers";
import useStorage from "../../../helpers/useStorage";
import useCompanyOptions from "../CommonDeliverables/useCompanyOptions";
import { ACS_EVENT_TYPES_OPTIONS, reportDateFormat } from "../../../constants";
import useContractOptions from "../CommonDeliverables/useContractOptions";
import ClearButton from "../ClearButton/ClearButton";
import LazyLoadedSelect from "../../LazyLoadedSelect/LazyLoadedSelect";
import {
  defaultSelectOption,
  selectOptionsDefaultOptionAppender,
  defaultFromDateFilterValue,
  defaultToDateFilterValue,
  formatValueWithDefaultOption,
  getFilterDateRange,
} from "../../../helpers/utils";
import CustomSelectClearIndicator from "../CustomSelectClearIndicator/CustomSelectClearIndicator";
import useSiteOptions from "../CommonDeliverables/useSiteOptions";
const AcsReportFilter = ({
  filterDateRange,
  requestDataType,
  onSearchInputChange,
  onEventTimeFromChange,
  onApplicantTypeChange,
  onCompanyChange,
  onEventChange,
  handleUpdateKey,
  onEventTimeToChange,
  onExport,
  setCurrentPageNumber,
  onContractChange,
  onSiteChange,
  setResetPagination,
  onResetInitiated,
  buttonVisibility,
  handleInitialFiltersDone,
  loading,
}) => {
  const { setToStorage, getFromStorage, removeFromStorage } = useStorage();
  const [initialFilterDone, setInitialFilterDone] = React.useState(false);

  const { userRoleDetails } = useContext(AppContext);
  const {
    companies,
    handleCompanySearch,
    loadNextCompanyOptionsPage,
    isCompanyLoading,
  } = useCompanyOptions();
  const {
    contracts,
    handleContractSearch,
    loadNextContractOptionsPage,
    isContractLoading,
  } = useContractOptions();

  const { sites, loadNextSiteOptionsPage, handleSiteSearch, isSiteLoading } =
    useSiteOptions();

  const [searchText, setSearchText] = React.useState(
    getFromStorage("acs_report_filter_search") ?? "",
  );

  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);
  const [minDate, setMinDate] = React.useState(null);
  const [maxDate, setMaxDate] = React.useState(null);

  const [type, setType] = React.useState(
    getFromStorage("acs_report_filter_type") ?? defaultSelectOption(),
  );
  const [company, setCompany] = React.useState(
    getFromStorage("acs_report_filter_company") ?? defaultSelectOption(),
  );
  const [contract, setContract] = React.useState(
    getFromStorage("acs_report_filter_contractor") ?? defaultSelectOption(),
  );

  const [site, setSite] = React.useState(
    getFromStorage("acs_report_filter_site") ?? defaultSelectOption(),
  );
  const [event_type, setEventType] = React.useState(
    getFromStorage("acs_report_filter_event") ?? defaultSelectOption(),
  );
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const [dateRange, setDateRange] = React.useState(null);
  const [minMaxRange, setMinMaxRange] = React.useState(null);

  React.useEffect(() => {
    if (!filterDateRange?.defaultDurationValue) return;

    let maxMinDateRange = getFilterDateRange(
      filterDateRange?.retentionValue,
      filterDateRange?.retentionUnit,
    );
    setMinMaxRange(maxMinDateRange);
    setMinDate(new Date(maxMinDateRange?.from));
    setMaxDate(new Date(maxMinDateRange?.to));

    const newDateRange = getFilterDateRange(
      filterDateRange?.defaultDurationValue,
      filterDateRange?.defaultDurationUnit,
    );

    setDateRange(newDateRange);

    setFromDate(newDateRange?.from);
    fromDateRef.current?.handleChange(newDateRange?.from);
    setToDate(newDateRange?.to);
    toDateRef.current?.handleChange(newDateRange?.to);
  }, [filterDateRange]);

  useEffect(() => {
    handleInitialFiltersDone(initialFilterDone);
  }, [initialFilterDone]);

  useEffect(() => {
    if (initialFilterDone) return;
    if (
      fromDate &&
      toDate &&
      moment(fromDate).isValid() &&
      moment(toDate).isValid()
    ) {
      setInitialFilterDone(true);
      applyFilters();
    }
  }, [fromDate, toDate, initialFilterDone]);

  React.useEffect(() => {
    if (!searchText) {
      onSearchInputChange("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const { pagePermissions } = React.useContext(AppContext);

  const parseToSelectFormat = (options, keys) => {
    let res = _.map(options, (option) => ({
      label: option[keys.label],
      value: option[keys.value],
    }));
    res.unshift(defaultSelectOption());
    return res;
  };

  const onFilterChange = (option) => {
    const { name, value, label } = option;

    switch (name) {
      case "toDate":
        setToDate(value === null ? "" : moment(value).format(reportDateFormat));
        toDateRef.current.handleChange(moment(value).format(reportDateFormat));

        break;
      case "fromDate":
        setFromDate(
          value === null ? "" : moment(value).format(reportDateFormat),
        );
        fromDateRef.current.handleChange(
          moment(value).format(reportDateFormat),
        );

        break;
      case "type":
        setType({ label, value });

        break;
      case "company":
        setCompany({ label, value });
        break;
      case "contract":
        setContract({ label, value });
        break;
      case "site":
        setSite({ label, value });

        break;
      case "event_type":
        setEventType({ label, value });

        break;
      default:
        break;
    }
  };

  const applyFilters = () => {
    removeFromStorage();
    setToStorage({
      acs_report_filter_from_date: fromDate ?? "",
      acs_report_filter_to_date: toDate ?? "",
      acs_report_filter_type: type ?? "",
      acs_report_filter_company: company ?? "",
      acs_report_filter_contractor: contract ?? "",
      acs_report_filter_site: site ?? "",
      acs_report_filter_search: searchText ?? "",
      acs_report_filter_event: event_type ?? "",
    });
    onEventTimeToChange(toDate);
    onEventTimeFromChange(fromDate);
    onApplicantTypeChange(type?.value);
    onEventChange(event_type?.value);
    onCompanyChange(company?.label == "Select" ? "" : company?.value);
    setResetPagination();
    onContractChange(contract?.value);
    onSiteChange(site?.value);
    setCurrentPageNumber(1);
    handleUpdateKey();
    onSearchInputChange(searchText);
  };

  const handleSingleFieldReset = (field) => {
    switch (field) {
      case "category":
        setType(defaultSelectOption());
        return;
      case "company":
        setCompany(defaultSelectOption());
        return;
      case "contract":
        setContract(defaultSelectOption());
        return;
      case "site":
        setSite(defaultSelectOption());
        return;
      case "eventType":
        setEventType(defaultSelectOption());
        return;
      case "search":
        setSearchText("");
        return;
      case "fromTime":
        setFromDate("");
        fromDateRef.current.handleChange("");
        return;
      case "toTime":
        setToDate("");
        toDateRef.current.handleChange("");
        return;
      default:
        return;
    }
  };

  const resetFilterOptions = () => {
    setToDate(dateRange?.to);
    toDateRef.current.handleChange(dateRange?.to);
    setFromDate(dateRange?.from);
    fromDateRef.current.handleChange(dateRange?.from);
    onEventTimeFromChange(dateRange?.from);
    toDateRef.current.handleChange(dateRange?.to);
    setType(defaultSelectOption());
    setEventType(defaultSelectOption());
    setCompany(defaultSelectOption());
    setContract(defaultSelectOption());
    setSite(defaultSelectOption());
    setSearchText("");
    onResetInitiated();
    setCurrentPageNumber(1);
    removeFromStorage();
    handleUpdateKey();
    setMinDate(new Date(minMaxRange?.from));
    setMaxDate(new Date(minMaxRange?.to));
  };

  return (
    <div className="reports-filter-section pb-3 position-relative">
      <div className="row mb-2">
        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2">
          <span>Category</span>
          <SelectApplicants
            showClearButton={true}
            searchByApplicantType={(opt) =>
              onFilterChange({
                name: "type",
                value: String(opt?.value ?? "").length ? opt?.label : "",
                label: opt?.label,
              })
            }
            applicantType={type}
            additionalOptions={{
              label: "Override Pass",
              value: "OVERRIDE_PASS",
            }}
          />
          {/* <Select
            className="cutomSelect"
            classNamePrefix="react-select"
            value={type}
            options={applicantType}
            onChange={(opt) =>
              onFilterChange({
                name: "type",
                value: opt.value,
                label: opt.label,
              })
            }
            name="type"
            placeholder="Select"
          /> */}
        </div>

        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2 select-holder">
          <span>Company</span>
          <LazyLoadedSelect
            className="cutomSelect"
            classNamePrefix="react-select"
            loadNextOptions={loadNextCompanyOptionsPage}
            name="company"
            onChange={(opt) =>
              onFilterChange({
                name: "company",
                value: opt?.value,
                label: opt?.label,
              })
            }
            onInputChange={(value) => handleCompanySearch(value)}
            options={selectOptionsDefaultOptionAppender(companies)}
            placeholder="Select"
            value={formatValueWithDefaultOption(company)}
            isLoading={isCompanyLoading}
            isClearable={true}
            defaultValue={defaultSelectOption()}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2 select-holder">
          <span>Contract</span>
          <LazyLoadedSelect
            className="cutomSelect"
            classNamePrefix="react-select"
            loadNextOptions={loadNextContractOptionsPage}
            name="contract"
            onChange={(opt) =>
              onFilterChange({
                name: "contract",
                value: opt?.value,
                label: opt?.label,
              })
            }
            onInputChange={(value) => handleContractSearch(value)}
            options={selectOptionsDefaultOptionAppender(contracts, true)}
            placeholder="Select"
            value={formatValueWithDefaultOption(contract)}
            isLoading={isContractLoading}
            isClearable={true}
            defaultValue={defaultSelectOption()}
          />
        </div>

        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2 select-holder">
          <span>Site</span>
          <LazyLoadedSelect
            className="cutomSelect"
            classNamePrefix="react-select"
            loadNextOptions={loadNextSiteOptionsPage}
            name="site"
            onChange={(opt) =>
              onFilterChange({
                name: "site",
                value: opt?.value,
                label: opt?.label,
              })
            }
            onInputChange={(value) => handleSiteSearch(value)}
            options={selectOptionsDefaultOptionAppender(sites, true)}
            placeholder="Select"
            value={formatValueWithDefaultOption(site)}
            isLoading={isSiteLoading}
            isClearable={true}
            defaultValue={defaultSelectOption()}
          />
        </div>

        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2">
          <span>Event Time From</span>
          <div className="position-relative">
            <CustomCalendar
              maxDate={maxDate ? maxDate : moment().toDate()}
              minDate={minDate ? minDate : ""}
              dateFormat={reportDateFormat}
              timePicker
              ref={fromDateRef}
              selected={
                fromDate === "" || fromDate === null ? "" : new Date(fromDate)
              }
              onChange={(date) => {
                setMinDate(new Date(date));
                onFilterChange({ name: "fromDate", value: date, label: "" });
              }}
              isClearable={true}
              onClear={() => handleSingleFieldReset("fromTime")}
            />
            {loading && (
              <span className="input-inline-loader-container">
                <div
                  className="spinner-border spinner-border-sm ml-5"
                  role="status"
                ></div>
              </span>
            )}
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2">
          <span>Event Time To</span>
          <div className="position-relative">
            <CustomCalendar
              maxDate={moment().toDate()}
              minDate={fromDate ? fromDate : minDate}
              dateFormat={reportDateFormat}
              ref={toDateRef}
              selected={
                toDate === "" || toDate === null ? "" : new Date(toDate)
              }
              onChange={(date) => {
                setMaxDate(date);
                onFilterChange({ name: "toDate", value: date, label: "" });
              }}
              timePicker
              isClearable={true}
              onClear={() => handleSingleFieldReset("toTime")}
            />
            {loading && (
              <span className="input-inline-loader-container">
                <div
                  className="spinner-border spinner-border-sm ml-5"
                  role="status"
                ></div>
              </span>
            )}
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2 select-holder">
          <span>Event Type</span>
          <Select
            className="cutomSelect"
            classNamePrefix="react-select"
            value={formatValueWithDefaultOption(event_type)}
            options={parseToSelectFormat(ACS_EVENT_TYPES_OPTIONS, {
              label: "label",
              value: "value",
            })}
            onChange={(opt) =>
              onFilterChange({
                name: "event_type",
                value: opt?.value ?? "",
                label: opt?.label ?? "",
              })
            }
            name="event_type"
            placeholder="Select"
            isClearable={true}
            components={{ ClearIndicator: CustomSelectClearIndicator }}
            defaultValue={defaultSelectOption()}
          />
        </div>

        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2">
          <span>Search</span>
          <div
            className="report-search-container searchHolder mb-0"
            // onSubmit={(e) => onSubmitSearch(e)}
          >
            <input
              type="text"
              className="form-control"
              name="search"
              value={searchText}
              id="search"
              placeholder="Search by Person name or Profile id"
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            />
            <ClearButton
              onClick={() => handleSingleFieldReset("search")}
              hideClear={String(searchText ?? "").length == 0}
            />
            {/* <button className="btn btn-primary" type="submit">
              <span className="simple-icon-magnifier"></span>
            </button> */}
          </div>
        </div>
        <div className="row m-0 flx-end w-100 justify-content-end">
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-0  mt-2 p-0 px-1 px-lg-2 d-flex justify-content-end">
            <span className="show-lg">&nbsp;</span>
            <div className="btn-cover ">
              <button
                onClick={() => applyFilters()}
                className="btn btn-secondary rounded-0 ml-1 "
              >
                Apply
              </button>
              <button
                onClick={resetFilterOptions}
                className="btn btn-secondary reset rounded-0 ml-1 "
              >
                <i className="iconsminds-repeat-2"></i>
              </button>
              {checkModuleGeneralPermission(
                userRoleDetails,
                "acs-event-report",
                "export_report",
              ) && (
                <button
                  onClick={onExport}
                  className="btn btn-secondary  rounded-0 ml-1"
                  disabled={buttonVisibility}
                >
                  Export
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcsReportFilter;
